const MAX_NOTIFICATION_BEFORE_QUEUE = 5;
const DEFAULT_NOTIFICATION_DURATION_MS = 10000;
const ANIMATION_TIMEOUT = 300;
export { ANIMATION_TIMEOUT, DEFAULT_NOTIFICATION_DURATION_MS, MAX_NOTIFICATION_BEFORE_QUEUE };
